const isOptionFit = (item, sourceItem) =>
  item.options.some((option) => option.value === sourceItem.value);

const getDisplayOptionsToUpdate = (source, destination) =>
  destination.reduce((diff, item) => {
    const sourceItem = source.find((el) => el.id === item.id);
    if (!sourceItem) return diff;

    const { options } = item;

    if (
      !options ||
      isOptionFit(item, sourceItem) ||
      (Number.isInteger(item.index) && item.index && !sourceItem.value)
    ) {
      diff.push(sourceItem);
      return diff;
    }

    const defaultValue = item.options[0].value;
    diff.push({
      ...sourceItem,
      value: defaultValue,
      options,
      sourceOptions: sourceItem.options,
    });

    return diff;
  }, []);

export default getDisplayOptionsToUpdate;
